import { Dialog, DialogFooter, DialogType, IDialogContentProps, PrimaryButton } from '@fluentui/react';
import React, { useMemo } from 'react';
import { fontFamily } from '../../../../app-core/app-theme';
import { isTouchDevice } from '../../../../framework/utils/device';

interface IShoppingIntroDialogProps {
  showDialog: boolean;
  title: string;
  plainContent?: string | undefined;
  richContent?: JSX.Element | undefined;
  dismissButtonText?: string | undefined;
  onClose: () => void;
}

const getDialogContentProps = (title: string) => {
  const props: IDialogContentProps = {
    type: DialogType.largeHeader,
    title,
  };
  return props;
}

const modalProps = {
  isBlocking: false,
  styles: { main: { fontFamily: fontFamily, '@media (min-width: 480px)': { width: '50%', minWidth: 340, maxWidth: 650 }} },
  allowTouchBodyScroll: isTouchDevice(),
};

export const ShoppingIntroDialog: React.FunctionComponent<IShoppingIntroDialogProps> = (props) => {
  const { title } = props;
  const dialogContentProps = useMemo(() => getDialogContentProps(title), [title]);

  return (
    <Dialog
      hidden={props.showDialog === false}
      onDismiss={props.onClose}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
    >
      {!!props.plainContent && props.plainContent}
      {!!props.richContent && props.richContent}
      <DialogFooter>
        <PrimaryButton onClick={props.onClose} text={props.dismissButtonText ?? "Let's do it"} />
      </DialogFooter>
    </Dialog>
  );
};
